import React, { FC } from 'react'

import { IconConnectedDevicesProps } from './IconConnectedDevices.types'
import * as Styled from './styles/IconConnectedDevices.style'

import { nonThemeableRules } from '../../ruleSet'

const IconConnectedDevices: FC<IconConnectedDevicesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconConnectedDevicesProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconConnectedDevicesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M140 120h-8a4 4 0 0 0 0 8h8a4 4 0 0 0 0-8zm-100 0h-8a4 4 0 1 0 0 8h8a4 4 0 0 0 0-8z' />
        <path d='M152 64.2v-41A15 15 0 0 0 137.26 8H22.67A14.92 14.92 0 0 0 8 23.09v17.2a10 10 0 0 0-8 9.8V134a10 10 0 0 0 10 10h52.08a10 10 0 0 0 10-10v-6h27.75a4 4 0 0 0 0-8H84v-7.81h28V134a10 10 0 0 0 10 10h28a10 10 0 0 0 10-10V74a10 10 0 0 0-8-9.8zM64.08 134a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V50.09a2 2 0 0 1 2-2h52.08a2 2 0 0 1 2 2zM76 120h-3.92v-7.81H76zm4-15.81h-7.92v-54.1a10 10 0 0 0-10-10H16V23a6.92 6.92 0 0 1 6.74-7h114.45a6.94 6.94 0 0 1 6.81 7.1V64h-22a10 10 0 0 0-10 10v30.19zM152 134a2 2 0 0 1-2 2h-28a2 2 0 0 1-2-2V74a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconConnectedDevices
